import { Collapse } from "bootstrap";

import { jarallax, jarallaxVideo } from "jarallax";
jarallaxVideo();
jarallax(document.querySelectorAll(".jarallax"));

import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import Mmenu from 'mmenu-js';

var swiper = new Swiper(".swiper", {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1,
    spaceBetween: 30,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
        pauseOnMouseEnter: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    autoplay: {
        delay: 2500,
        pauseOnMouseEnter: true,
    },
    breakpoints: {
        576: {
            slidesPerView: 1,
            spaceBetween: 30,
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
        1400: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
    },
});



